import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { SPEED_OPTIONS, SPEED_LABELS } from '../lib/speech';

// The speed dropdown, inside the white phrase card. One component for Manual
// and Automatic (Leanne, 21 Oct 2026: Automatic's sat outside the card).
export default function SpeedControl({ value, onChange, disabled = false, className = '', testId = 'practice-speed-control' }) {
    return (
        <div className={`flex items-center justify-center gap-2 ${className}`} data-testid={testId}>
            <span className="text-xs text-stone-400">Speed</span>
            <Select value={String(value)} onValueChange={(v) => onChange(parseFloat(v))} disabled={disabled}>
                <SelectTrigger data-testid="practice-speed-select" className="h-7 w-36 text-xs bg-stone-50 border-stone-200 text-foreground rounded-full">
                    <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-white text-foreground">
                    {SPEED_OPTIONS.map(speed => (
                        <SelectItem key={speed} value={String(speed)} className="text-foreground">{SPEED_LABELS[speed] || `${speed}x`}</SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
